<template>
  <ais-pagination
    @page-change="returnToTop"
    :showFirst="false"
    :showLast="false"
    class="justify-content-center py-4"
    :classNames="{
      'ais-Pagination': 'pagination',
      'ais-Pagination--noRefinement': 'disabled',
      'ais-Pagination-list': 'pagination',
      'ais-Pagination-item': 'page-item',
      'ais-Pagination-item--firstPage': 'first-page',
      'ais-Pagination-item--lastPage': 'last-page',
      'ais-Pagination-item--previousPage': 'prev-page',
      'ais-Pagination-item--nextPage': 'next-page',
      'ais-Pagination-item--page': 'page',
      'ais-Pagination-item--selected': 'active',
      'ais-Pagination-item--disabled': 'disabled',
      'ais-Pagination-link': 'page-link'
    }"
    :padding="2">
    <template v-slot:previous="{ createURL, isFirstPage, refine }">
      <button
        v-show="!isFirstPage"
        :href="createURL()"
        @click.prevent="refine()"
        class="page-link"
      >
        Previous
      </button>
    </template>

    <template v-slot:next="{ createURL, isLastPage, refine }">
      <button
        v-show="!isLastPage"
        :href="createURL()"
        @click.prevent="refine()"
        class="page-link"
      >
        Next
      </button>
    </template>
  </ais-pagination>
</template>

<script>
import { AisPagination } from 'vue-instantsearch/vue3/es';

export default {
  name: 'SearchPagination',
  components: {
    AisPagination,
  },
  methods: {
    returnToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
